import {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cil3d,
  cilAirplaneMode,
  cilAirplay,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplications,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowThickFromBottom,
  cilArrowThickFromTop,
  cilArrowThickToBottom,
  cilArrowThickTop,
  cilArrowThickToTop,
  cilBan,
  cilBasket,
  cilBeaker,
  cilBell,
  cilBellExclamation,
  cilBlur,
  cilBold,
  cilBookmark,
  cilBuilding,
  cilBusAlt,
  cilCalculator,
  cilCalendar,
  cilCenterFocus,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCog,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilExternalLink,
  cilEuro,
  cilEyedropper,
  cilExitToApp,
  cilGlobeAlt,
  cilGrid,
  cilFeaturedPlaylist,
  cilFile,
  cilFingerprint,
  cilFullscreen,
  cilFullscreenExit,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInput,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilMenu,
  cilNotes,
  cilOptions,
  cilPaintBucket,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilRouter,
  cilSave,
  cilScreenSmartphone,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilStorage,
  cilSun,
  cilSync,
  cilTags,
  cilTask,
  cilTransfer,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilXCircle,
  cilWarning,
  cilVolumeHigh,
  cilVolumeOff
} from '@coreui/icons'
import { logo } from './logo'


export const iconsSet = Object.assign({}, { logo }, {
  cil3d,
  cilAirplaneMode,
  cilAirplay,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplications,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowThickFromBottom,
  cilArrowThickFromTop,
  cilArrowThickToBottom,
  cilArrowThickTop,
  cilArrowThickToTop,
  cilBan,
  cilBasket,
  cilBeaker,
  cilBell,
  cilBellExclamation,
  cilBlur,
  cilBold,
  cilBookmark,
  cilBuilding,
  cilBusAlt,
  cilCalculator,
  cilCalendar,
  cilCenterFocus,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCog,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilExternalLink,
  cilEuro,
  cilEyedropper,
  cilExitToApp,
  cilGlobeAlt,
  cilGrid,
  cilFeaturedPlaylist,
  cilFile,
  cilFingerprint,
  cilFullscreen,
  cilFullscreenExit,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInput,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilMenu,
  cilNotes,
  cilOptions,
  cilPaintBucket,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilRouter,
  cilSave,
  cilScreenSmartphone,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilStorage,
  cilSun,
  cilSync,
  cilTags,
  cilTask,
  cilTransfer,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilXCircle,
  cilWarning,
  cilVolumeHigh,
  cilVolumeOff
}, {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
}, {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
})
